import { TinyCourse, } from 'src/course/domain/CourseEditModel';
import DirtyTheme from './DirtyTheme';
import { useI18n } from 'src/utils/lni18n';
import { useDialog } from 'src/components/Modalservice/Dialogservice';
import { PublishAllPartsDialog, PublishAllPartsDialogProps } from './PublishAllPartsDialog';
import { useMemo } from 'react';

export default function DirtyPartsTree(props: { course: TinyCourse }) {

    const { languageService: t } = useI18n();
    const dialogPortal = useDialog();

    const hasDirtyParts = useMemo( ()=> props.course.Themes
        .flatMap(t => t.Parts)
        .filter(p => p.Dirty)
        .map(p => p.Id), [props.course] );

    const publishAll = () => {

        dialogPortal({
            factory: (_, onCancel) => {
                const dprops: PublishAllPartsDialogProps = {
                    languageService: t,
                    onCancel: onCancel,
                    partIds: hasDirtyParts
                }
                return <PublishAllPartsDialog {...dprops} />
            },
            size: "xl"
        }).then(() => {
        }).catch((e: Error) => { /* no logging needed - this just means the user cancelled */ })    }

    return (
        <div className='mb-3'>
            {hasDirtyParts.length > 0 &&
                <button type="button" onClick={publishAll} className="mb-3 btn btn-primary btn-small" >{t.getText("publish.all.parts")}</button>
            }

            {props.course.Themes.filter(t => t.Parts.find(p => p.Dirty))
                .map(t => <DirtyTheme key={t.Id} courseId={props.course.Id} theme={t} />)}

        </div>
    )
}
